export const Kind = 'TRAINING_SEGMENTS' as const;

export enum Status {
  TranscribingPending = 'TRANSCRIBING_PENDING',
  Transcribing = 'TRANSCRIBING',
  TranscribingNeedsReview = 'TRANSCRIBING_NEEDS_REVIEW',
  Done = 'DONE',
}
